module.exports = __webpack_public_path__ + "img/Upload.766d4b7b.png";